export class ContactService {
    webClientService;
    static $inject = ['WebClientService'];
    constructor(webClientService) {
        this.webClientService = webClientService;
    }
    requiredDetails(contactReceiver) {
        return new Promise((resolve, reject) => {
            if (contactReceiver.systemContact === undefined) {
                this.webClientService.requestContactDetail(contactReceiver)
                    .then((data) => resolve(data))
                    .catch((data) => reject(data));
            }
            else {
                resolve(contactReceiver);
            }
        });
    }
}
